import {
    FONTS_ROUTE
} from './constants';
import http from '../../utils/httpService';

/**
 *
 * @param file
 */
const requestStoreFont = file => {
    const requestBody = new FormData();
    requestBody.append( 'font', file );
    return http.request( FONTS_ROUTE, 'POST', requestBody, true );
};
/**
 *
 */
const requestFontsList = () => {
    return http.request( FONTS_ROUTE, 'GET' );
};

export {
    requestStoreFont,
    requestFontsList
};
